import { Exception } from '../../exceptions/exception';

export class RouteTitleNotFoundException extends Exception {
  public constructor(name: string) {
    super(`The route title "${name}" not found.`);
  }
}
